import * as api from '../api';

const fetchEnrolledProgramsActions = api.fetchActions('programs', 'fetch-enrolled-programs');
const fetchEnrolledProgramFormPermissionsActions = api.fetchActions('programs', 'fetch-enrolled-form-permissions');

export const actionTypes = {
  ...fetchEnrolledProgramsActions.actionTypes,
  ...fetchEnrolledProgramFormPermissionsActions.actionTypes
}

export const fetchEnrolledPrograms = (participantId) =>
  api.getThunk(`/participants/enrollment`, {participantId}, fetchEnrolledProgramsActions, null);

export const fetchEnrolledProgramFormPermissions = (participantId) =>
  api.getThunk(`/participants/participant-forms`, {participantId}, fetchEnrolledProgramFormPermissionsActions, null);



// WEBPACK FOOTER //
// src/programs/program-permissions.actions.js